'use client'

import {
  Accordion,
  Container,
  Divider,
  Group,
  Stack,
  Text,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { FC } from 'react'
import { ActionReusableDesign } from './ActionReusable'

interface QuickActionFooterProps {
  links: any[]
  address: string
}

export const QuickActionFooter: FC<QuickActionFooterProps> = ({
  links,
  address,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const [streetLine, phone, email] = address.split('\n')
  const [street, cityCountry] = streetLine.split(', Cairo')

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: ' #1f2021',
        color: '#fff',
        boxSizing: 'border-box',
      }}
    >
      <Container size='xl' px={0}>
        {isMobile ? (
          <Accordion
            variant='separated'
            chevronPosition='right'
            transitionDuration={200}
            styles={{
              item: {
                backgroundColor: 'transparent',
                border: 'none',
              },
              control: {
                color: '#FFFFFF',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                // padding: '14px 0',
              },
              content: {
                padding: '0 0 10px 25px',
              },
            }}
          >
            {links.map((section, index) => (
              <div key={section.title}>
                {/* Divider ABOVE each accordion */}
                <Divider w='100%' color='#DDE4EA2E' />

                <Accordion.Item value={section.title}>
                  <Accordion.Control>{section.title}</Accordion.Control>
                  <Accordion.Panel>
                    {section.items.map((item: any, idx: number) => (
                      <Text
                        key={idx}
                        component='a'
                        href={item.url}
                        style={{
                          display: 'block',
                          color: '#FFFFFF',
                          fontSize: '13px',
                          lineHeight: '160%',
                          marginBottom: '8px',
                          textDecoration: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        {item.label}
                      </Text>
                    ))}
                  </Accordion.Panel>
                </Accordion.Item>
              </div>
            ))}

            <Divider color='#DDE4EA2E' />
            <Accordion.Item value='address'>
              <Accordion.Control>Address</Accordion.Control>
              <Accordion.Panel>
                <Text fz='13px' lh='160%' c='#FFFFFF'>
                  {street},
                  <br />
                  Cairo{cityCountry}
                </Text>

                <Text fz='13px' c='#FFFFFF'>
                  {phone}
                </Text>

                <Text fz='13px' c='#FFFFFF'>
                  {email}
                </Text>
              </Accordion.Panel>
            </Accordion.Item>
            <Divider color='#DDE4EA2E' />
          </Accordion>
        ) : (
          <Group
            align='flex-space-between'
            style={{
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              width: '100%',
              margin: 0,
              padding: 0,
            }}
          >
            {links.map((section, index) => (
              <ActionReusableDesign key={index} {...section} />
            ))}

            {/* Static company info column */}
            <Stack style={{ minWidth: 180 }}>
              <Text
                style={{
                  color: '#FFFFFFB3',
                  fontSize: '14px',
                  fontWeight: 500,
                  fontFamily: 'Poppins, sans-serif',
                  marginBottom: '6px',
                }}
              >
                Address
              </Text>
              <Text fz='13px' lh='160%' c='#FFFFFF'>
                {street},
                <br />
                Cairo{cityCountry}
              </Text>

              <Text fz='13px' c='#FFFFFF'>
                {phone}
              </Text>

              <Text fz='13px' c='#FFFFFF'>
                {email}
              </Text>
            </Stack>
          </Group>
        )}
      </Container>
    </div>
  )
}
